import api from 'services/api';

export async function getUserInfo() {
  return api.get('/api/dashboard/me');
}
